export default (value) => {
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (value === 0) return '0 Byte';
  const i = parseInt(Math.floor(Math.log(value) / Math.log(1024)), 10);
  const round = Math.round(value / (1024 ** i), 2);
  return `${round} ${sizes[i]}`;
};



// WEBPACK FOOTER //
// ./src/filters/ConvertToByte.js